<template>
  <div
    class="limited-time-activity"
    id="limitedTimeActivity"
    v-if="limitedTimeActivityShow"
  >
    <section-title
      :title="letter.limitedTimeActivityTitle"
      class="activity-title"
    ></section-title>
    <p class="activity-time">{{ limitedTimeActivityTime }}</p>
    <div class="activity-award-wrap">
      <template v-for="task in taskList">
        <limited-time-task-list-item
          v-if="task.award.length > 1"
          :task="task"
          :weeklyTime="weeklyTime"
          :monthlyTime="monthlyTime"
          :payMonth="payMonth"
          @checkAwardDetail="checkAwardDetail"
          @toGetAward="toGetAward"
        />
        <limited-time-task-item
          v-else
          :task="task"
          :weeklyTime="weeklyTime"
          :monthlyTime="monthlyTime"
          :payMonth="payMonth"
          @checkAwardDetail="checkAwardDetail"
          @toGetAward="toGetAward"
        />
      </template>
    </div>
    <div class="activity-tips-wrap">
      <a href="javascript:;" class="btn" @click="showRulePopupFn">{{
        letter.limitedTimeActivityRule
      }}</a>
      <a href="javascript:;" class="btn" @click="showRecordPopupFn">{{
        letter.limitedTimeActivityRecord
      }}</a>
      <a
        v-if="visibleNoticeButton"
        href="javascript:;"
        class="btn"
        @click="showNotice"
        >{{ noticeButtonText }}</a
      >
    </div>

    <LimitedTimeRulePopup
      @onClose="showRulePopup = false"
      :visible="showRulePopup"
    ></LimitedTimeRulePopup>
    <LimitedTimeRecordPopup
      @onClose="showRecordPopup = false"
      :visible="showRecordPopup"
    ></LimitedTimeRecordPopup>
    <limitedTimeAwardDeatailPopup
      @onClose="showAwardDetailPopup = false"
      :awardDetail="chooseAwardDetail"
      :visible="showAwardDetailPopup"
    ></limitedTimeAwardDeatailPopup>
    <LimitedTimeSelectRolePopup
      @onCancle="showSelectRolePopup = false"
      @onConfirm="getAward"
      :awardDetail="chooseAwardDetail"
      :visible="showSelectRolePopup"
    ></LimitedTimeSelectRolePopup>
    <PopupWindow
      v-if="showTipPopup"
      type="tips"
      :languages="letter"
      :content="popupTip"
      textAlign="center"
      @onConfirm="showTipPopup = false"
      @onCancel="showTipPopup = false"
    ></PopupWindow>
  </div>
</template>

<script type="text/javascript">
import globalConfig from '@utiles/officialStore/globalConfig';
import { UPDATE_LOADING } from '@store/officialStore';
import SectionTitle from '@components/officialStore/SectionTitle.vue';
import LimitedTimeAwardList from '@components/officialStore/activity/LimitedTimeAwardList.vue';
import LimitedTimeTaskItem from '@components/officialStore/activity/LimitedTimeTaskItem.vue';
import LimitedTimeTaskListItem from '@components/officialStore/activity/LimitedTimeTaskListItem.vue';

import LimitedTimeRulePopup from '@components/officialStore/activity/LimitedTimeRulePopup.vue';
import LimitedTimeRecordPopup from '@components/officialStore/activity/LimitedTimeRecordPopup.vue';
import limitedTimeAwardDeatailPopup from '@components/officialStore/activity/LimitedTimeAwardDeatailPopup.vue';
import LimitedTimeSelectRolePopup from '@components/officialStore/activity/LimitedTimeSelectRolePopup.vue';
import {
  LIMITED_TIME_ACTIVITY_BASIC,
  LIMITED_TIME_ACTIVITY_AWARD
} from '@store/officialStore/event';
import { mapState, mapGetters } from 'vuex';
import {
  countDownTimeFormat,
  timestampToDateFormat
} from '@utiles/officialStore';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV1';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
const awardStatusMap = {
  notAchieve: 0,
  canGet: 1,
  hasGot: 2
};
export default {
  name: 'limitedTimeActivity',
  mixins: [],
  props: ['visibleNoticeButton', 'noticeButtonText'],
  data() {
    return {
      awardStatus: null,
      payWeek: 0,
      payMonth: 0,
      chooseAward: null,
      chooseAwardDetail: '',

      weeklyTime: 0,
      monthlyTime: 0,
      timer: null,

      showRulePopup: false,
      showRecordPopup: false,
      showAwardDetailPopup: false,
      showSelectRolePopup: false,
      showTipPopup: false,
      popupTip: ''
    };
  },
  watch: {},
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      showCurrency: state => state.showCurrency,
      limitedTimeActivityShow: state => state.event.limitedTimeActivityShow,
      limitedTimeActivityMonthStart: state =>
        state.event.limitedTimeActivityMonthStart,
      limitedTimeActivityMonthEnd: state =>
        state.event.limitedTimeActivityMonthEnd
    }),
    ...mapGetters(['gameInfoConfig']),
    limitedTimeActivityAwardList() {
      return this.gameInfoConfig.limitedTimeActivity.awardList;
    },
    taskList() {
      // 用于对象转数组+排序
      const awardObjList = Object.values(this.awardStatus || {});
      const curtaskList = awardObjList.map(task => {
        return {
          ...task,
          limitedPay: this.limitedTimeActivityAwardList[task.id].limitedPay,
          limitedTime: this.limitedTimeActivityAwardList[task.id].limitedTime,
          taskName:
            this.limitedTimeActivityAwardList[task.id].taskName[this.lang] ||
            this.limitedTimeActivityAwardList[task.id].taskName['default'],
          awardDetail:
            this.limitedTimeActivityAwardList[task.id].awardDetail[this.lang] ||
            this.limitedTimeActivityAwardList[task.id].awardDetail['default'],
          award: this.limitedTimeActivityAwardList[task.id].award
        };
      });
      const notAchieveList = curtaskList.filter(
        item => item.status === awardStatusMap.notAchieve
      );
      const canGetList = curtaskList.filter(
        item => item.status === awardStatusMap.canGet
      );
      const hasGotList = curtaskList.filter(
        item => item.status === awardStatusMap.hasGot
      );
      return [...canGetList, ...notAchieveList, ...hasGotList];
    },
    _weeklyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.weeklyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    _monthlyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.monthlyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    limitedTimeActivityTime() {
      const startDate = timestampToDateFormat(
        this.limitedTimeActivityMonthStart
      );
      const endDate = timestampToDateFormat(this.limitedTimeActivityMonthEnd);
      return this.letter.limitedTimeActivityTime
        .replace('${startDate}', startDate)
        .replace('${endDate}', endDate);
    }
  },
  async mounted() {
    await this.getLimitedTimeActivity();
    if (this.limitedTimeActivityShow) {
      setTimeout(() => {
        document.getElementById('limitedTimeActivity').scrollIntoView({
          block: 'end',
          inline: 'end',
          behavior: 'smooth'
        });
      }, 100);
    }
  },
  methods: {
    showNotice() {
      this.$emit('showNotice');
    },
    async getLimitedTimeActivity() {
      clearInterval(this.timer);
      try {
        const res = await this.$store.dispatch(LIMITED_TIME_ACTIVITY_BASIC, {
          currency: this.showCurrency
        });
        this.payWeek = res.data.payWeek;
        this.payMonth = res.data.payMonth;
        this.awardStatus = res.data.awardStatus;
        this.weeklyTime = res.data.countdownWeek;
        this.monthlyTime = res.data.countdownMonth;
        this.timer = setInterval(() => {
          this.weeklyTime--;
          this.monthlyTime--;
          if (this.weeklyTime <= 0 || this.monthlyTime <= 0) {
            this.getLimitedTimeActivity();
          }
        }, 1000);
      } catch (err) {
        console.log(err);
      }
    },
    checkAwardDetail(awardDetail) {
      this.chooseAwardDetail = awardDetail;
      this.showAwardDetailPopup = true;
    },
    toGetAward(award) {
      this.chooseAward = award;
      this.showSelectRolePopup = true;
      showPopup(popupType.confirmRolePopup);
    },
    async getAward(info) {
      const params = {
        id: this.chooseAward.id,
        currency: this.showCurrency,
        ...info
      };
      try {
        this.$store.commit(UPDATE_LOADING, true);
        const res = await this.$store.dispatch(
          LIMITED_TIME_ACTIVITY_AWARD,
          params
        );
        this.awardStatus[this.chooseAward.id].status = awardStatusMap.hasGot;
        this.popupTip = this.letter.limitedTimeActivityGetSucc;
        this.showTipPopup = true;
        window.webstorev1DataLayer.push({
          eventName: 'gift',
          eventType: 'events',
          eventReason: this.chooseAward.reason,
          eventReward: this.chooseAward.vtId,
          eventValue: res,
          ...getGlobalGetLinkParams({ acitivtyId: '2234' })
        });
      } catch (err) {
        this.popupTip = `[${err.code}] ${this.letter.limitedTimeActivityGetFail}`;
        this.showTipPopup = true;
        window.webstorev1DataLayer.push({
          eventName: 'gift_fail',
          eventType: 'events',
          eventReason: this.chooseAward.reason,
          eventReward: this.chooseAward.vtId,
          eventValue: {
            ...err,
            vtName: this.chooseAward.name
          },
          ...getGlobalGetLinkParams({ acitivtyId: '2234' })
        });
      } finally {
        this.chooseAward = null;
        this.showSelectRolePopup = false;
        this.$store.commit(UPDATE_LOADING, false);
      }
    },
    showRulePopupFn() {
      this.showRulePopup = true;
      showPopup(popupType.eventsRulePopup);
    },
    showRecordPopupFn() {
      this.showRecordPopup = true;
      showPopup(popupType.eventsBagPopup);
    },
    getTaskProcess(pay) {
      return this.letter.limitedTimeActivityTaskProcess
        .replace('${curPay}', this.payWeek)
        .replace('${targetPay}', pay);
    },
    getTaskName(pay, taskName) {
      return taskName
        .replace('${price}', pay)
        .replace('${currency}', this.showCurrency);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  components: {
    SectionTitle,
    LimitedTimeAwardList,
    LimitedTimeTaskItem,
    LimitedTimeTaskListItem,
    LimitedTimeRulePopup,
    LimitedTimeRecordPopup,
    limitedTimeAwardDeatailPopup,
    LimitedTimeSelectRolePopup
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-activity {
  .activity {
    &-title {
      margin: 39px auto;
    }
    &-time {
      text-align: center;
      font-size: 18px;
      color: var(--limited-time-activity-time-btn);
      margin-bottom: 38px;
    }
    &-award-wrap {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      column-gap: 17px;
      row-gap: 24px;
      margin: 0 28px;
    }
    &-tips-wrap {
      margin-top: 33px;
      text-align: center;

      .btn {
        // 不可换行
        white-space: nowrap;
        font-size: 22px;
        color: var(--limited-time-activity-time-btn);
      }
      .btn + .btn {
        margin-left: 32px;
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .limited-time-activity {
    .activity {
      &-award-wrap {
        margin: 0;
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}
</style>
